<template>
  <section class="app-main">
      <!-- <shiyanList ></shiyanList> -->
      <tenant></tenant>
      <div id="noticeT" v-if="this.noticeState == 1">
          <span class="svg-containerNT">
            <svg-icon icon-class="NotificatonOnButton" />
          </span>
          <div class="notice-titleT">
            <span :title="this.noticeTitle">{{this.noticeTitle}}</span>
          </div>
      </div>
  </section>
</template>

<script>
import request from '@/utils/request'
// import shiyanList from '@/components/myComponentsT/shiyanList'
import tenant from '@/components/myComponentsT/tenant'
export default {
  name: 'AppMainT',
  components:{
    // shiyanList
    tenant
  },
  data() {
    return {
      noticeTitle:'',
      noticeState:'',
    }
  },
  created(){
    this.shwoNotice();
  },
  methods: {
    shwoNotice(){
      request({
        method:'get',
        url:'api/notice/tokentrue'
      }).then(res=>{
        if(res.data == null){
          this.noticeState = 0
        }else{
          this.noticeState = res.data[0].state
          this.noticeTitle = res.data[0].content
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
}
</script>

<style scoped>
  @import './noticeT.css';
  .app-main{
    background: #f4f4f4;
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/AppMainT.vue